/**
 * Pick type-ahead suggestions for a ChipInput from a vocabulary list.
 *
 * With an empty draft, returns everything available (minus already-added values) —
 * the dropdown that renders these is already its own scroll container, so there's
 * no need to truncate the list; a hard cap here previously hid every entry past the
 * first `limit` alphabetically (e.g. only "A"-"C" ever showed until you typed a
 * query that happened to match something further down). Once the user types, it
 * narrows to case-insensitive substring matches. Already-added values are always
 * excluded (case-insensitive). Returns [] only when there's no vocabulary. Free
 * text is never blocked; these are hints layered over the free-text input.
 */
export function filterChipSuggestions(
  suggestions: string[] | undefined,
  draft: string,
  selected: string[],
  limit?: number
): string[] {
  if (!suggestions?.length) return []

  const query = draft.trim().toLowerCase()
  const taken = new Set(selected.map((s) => s.trim().toLowerCase()))
  const out: string[] = []
  for (const suggestion of suggestions) {
    const key = suggestion.trim().toLowerCase()
    if (!key || taken.has(key)) continue
    if (query && !key.includes(query)) continue
    out.push(suggestion)
    if (limit !== undefined && out.length >= limit) break
  }
  return out
}
